export enum SimulationModel {
    ByAbsolutePrices,
    ByRelativePrices,
    ByLogarithmicPrices
}
